<template>
    <div v-if="false === loading && 0 === groupings.length" class="container">
        <div class="row">
            <div class="col-12 text-center">
                {{t('noAvailableItems')}}
            </div>
        </div>
    </div>
    <div v-else-if="true === loading" class="container">
        <div class="row">
            <div class="col-12">
                <loading/>
            </div>
        </div>
    </div>
    <layout-two-column v-else>
        <template #column>
            <panel>
                <tree-view :items="groupings" :value="groupingActiveId" @select="navigate"/>
            </panel>
        </template>

        <template #default>

            <loading v-if="true === loading"/>
            <div v-else>
                <div class="pb-3 pt-3 pt-md-0">
                    <h1>{{title}}</h1>
                    <p v-html="description"></p>
                </div>

                <div v-if="0 === products.length">{{t('noAvailableItems')}}</div>

                <products-list :value="products" :grouping="groupingType" :grouping-id="groupingActiveId"/>
            </div>
        </template>
    </layout-two-column>
</template>

<script>

    import {mapGetters} from "vuex";
    import {get} from "lodash";

    import mixin_view from "@/mixins/view";
    import mixin_constraints from "@/mixins/constraints";
    import mixin_catalog from "@/mixins/catalog";
    import mixin_products from "@/mixins/products";
    import emitter from "@/api/events";
    import {HOME_PAGE_GROUPING_TYPE} from "@/constants";
    import {sanitize} from "@/helpers/html";
    import {getTranslationValue} from "@/i18n/utils/lang_overrides";
    import {retryRequest} from "@/helpers/request";

    import LayoutTwoColumn from "@/components/layout/LayoutTwoColumn";
    import Panel from "@/components/Panel";
    import ProductsList from "@/components/products/ProductsList";
    import TreeView from "@/components/TreeView";

    export default {
        name: "ViewsProducts",
        mixins: [mixin_view, mixin_constraints, mixin_catalog, mixin_products],
        components: {
            LayoutTwoColumn,
            Panel,
            ProductsList,
            TreeView
        },
        data() {

            return {
                t_path: "views.products",
                loading: false,
                category: {},
                products: [],
                empty: {}
            }
        },
        computed: {
            ...mapGetters({
                groupingActiveId: "grouping/activeId",
                groupingType: "grouping/type"
            }),
            title() {

                return getTranslationValue(this.category, "title", this.$i18n)
            },
            description() {

                return sanitize(getTranslationValue(this.category, "description", this.$i18n))
            },
            groupings() {

                return this.catalog_getCategories();
            }
        },
        methods: {
            navigate(id) {

                this.$store.dispatch("grouping/setActiveId", id);
            },
            fetch() {

                this.loading = true;

                emitter.emit('grouping_products_before_load')

                this
                    .catalog_fetchCategories({
                        type: get(this.$route.params, "grouping", HOME_PAGE_GROUPING_TYPE),
                        activeId: this.$route.params.grouping_id
                    })
                    .then(() => this.load())
                    .finally(() => this.loading = false);
            },
            refresh() {

                this.products_updateBreadcrumbsTree(this.$store.getters["grouping/active"]);

                this.view_setTitle(this.title);
            },
            load(groupingId) {

                emitter.emit('grouping_products_before_load')

                groupingId = groupingId ? groupingId : this.$route.params.grouping_id;

                return retryRequest(() => this.$platform.get(`/api/v2/grouping/${this.$route.params.grouping}/${groupingId}`))
                    .then(response => this.process(response.data.results))
                    .catch(error => this.base_error(error, true));
            },
            process(category) {

                this.category = category;

                this.products = "recommendation" === this.$route.params.grouping
                    ? category.products
                    : this.constraints_filterAvailableProducts(category.products, false, true);

                emitter.emit('grouping_products_after_load')

                this.loading = false;
            }
        },
        watch: {
            "$i18n.locale": function () {

                this.refresh();
            },
            groupingActiveId(groupingActiveId) {

                if (groupingActiveId && groupingActiveId != this.$route.params.grouping_id) {

                    this.$router.replace({params: {grouping_id: groupingActiveId}});

                    this.load(groupingActiveId);

                    this.refresh();
                }
            },
            category() {

                this.refresh();
            }
        },
        mounted() {

            this.fetch();

            emitter.on('user_constraints_fetch', this.load);
            emitter.on('user_cart_change', this.load);
        },
        beforeUnmount() {

            emitter.off('user_constraints_fetch', this.load);
            emitter.off('user_cart_change', this.load);
        }
    }
</script>